<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div>
  <div
    class="popover-conversion xrx-pb-2"
    [ngClass]="{ 'invalid-value': error.length && !param.selectedValue }">
    <!--Item 1-->
    <div class="from float-left">
      <xrx-popover
        [(param)]="param"
        [list]="param.options"
        [name]="param.name"
        [label]="param.label"
        [inlineLabel]="param.placeholder"
        [value]="param.value || ''"
        [(selectedValue)]="param.selectedValue"
        (change)="
          change.emit($event);
          doValidate(param.selectedValue, param.selectedValue2)
        "
        [showLabelOnTop]="true"
        [showIcon]="false"
        [valuePosition]="valuePosition"
        [disableIScroll]="true"
        [error]="error"></xrx-popover>
    </div>

    <!-- Converted to-->
    <div class="xgl-arrow"></div>

    <!--Item 2-->
    <div class="to">
      <xrx-popover
        [(param)]="param"
        [list]="param.options2"
        [name]="param.name2 || ''"
        [label]="param.label2 || ''"
        [inlineLabel]="param.placeholder2 || ''"
        [value]="param.value2 || ''"
        [(selectedValue)]="param.selectedValue2"
        (change)="
          change2.emit($event);
          doValidate(param.selectedValue, param.selectedValue2)
        "
        [showLabelOnTop]="true"
        [showIcon]="false"
        [valuePosition]="valuePosition"
        [disableIScroll]="true"
        [error]="error"></xrx-popover>
    </div>
  </div>
  @if (checkSame && param.value == param.value2) {
    <div>
      <span
        class="text-danger"
        [xdaTranslate]="'SDE_INPUT_LANGUAGE_OUTPUT'"></span>
    </div>
  }
  @if (!(checkSame && param.value == param.value2)) {
    <div><span [xdaTranslate]="param.description || ''"></span></div>
  }
</div>
